import React, { useState } from 'react';
import { ChevronDownIcon, Input, Menu, Pressable } from 'native-base';
import { useGeneralStyles } from '../../../shared/styles';
import { GiftCard, useSpringBigStore } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import OurPressable from '~/shared/Pressable';

const SelectLoyalty = ({
    loyaltyCard,
    setLoyaltyCard
}: {
    loyaltyCard: GiftCard | null,
    setLoyaltyCard: React.Dispatch<React.SetStateAction<GiftCard | null>>
}) => {

    const { giftCards, theme } = useSpringBigStore();
    const gStyle = useGeneralStyles();
    const [isOpen, setMenuOpen] = useState(false);

    const handlePress = () => {
        setMenuOpen(!isOpen);
    };

    return (
        <Input
            variant="underlined"
            p={2}
            keyboardType="numeric"
            placeholder="payment method"
            value={loyaltyCard?.card_number.slice(-5) || 'select royalty card'}
            isDisabled
            backgroundColor={'transparent'}
            color={gStyle.text}
            fontSize={18}
            fontWeight={300}
            InputRightElement={
                giftCards && giftCards.length > 0 ?
                <Menu
                    w={170}
                    padding={4}
                    borderRadius={24}
                    borderColor={gStyle.button_background}
                    backgroundColor={gStyle.screen_background}
                    borderWidth={1}
                    placement='bottom'
                    defaultIsOpen={false}
                    isOpen={isOpen}
                    onOpen={() => handlePress()}
                    onClose={() => handlePress()}
                    trigger={triggerProps => {

                        return <Pressable accessibilityLabel="More options menu" {...triggerProps}>
                            <ChevronDownIcon color={gStyle.button_background} size='lg' />
                        </Pressable>;
                    }}>

                    {giftCards.map((item) => {

                        return <Menu.Item key={item.card_number}>
                            <OurPressable onPress={() => setLoyaltyCard(item)}>
                                <Caption
                                    fontSize={22}
                                    fontWeight={200}
                                >
                                    {item.card_number.slice(-5)}
                                </Caption>
                            </OurPressable>
                        </Menu.Item>
                    })}
                </Menu>
                :
                <></>
            }
        />
    );
};

export default SelectLoyalty;
